export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    field: 'expand',
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: { content: 'expandContent' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzFlipOrderNo') || '翻单需求编号',
    field: 'amzFlipOrderNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '采购工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_isVc') || '是否VC产品',
    field: 'v_isVc',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'isVc' },
  },
  {
    title: that.$l('table_label_totalQty') || '采购数量',
    field: 'totalQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalFtyPrice') || '采购金额',
    field: 'totalFtyPrice',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_modifyByName') || '需求提交人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_modifyDate') || '需求时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
